module.exports = __webpack_public_path__ + "static/non-qualified-retirement-plan-desktop.01671458.webp";